package one.healthium.bland.providers

import ifaandroid.apps.bland.composeapp.generated.resources.Res
import one.primehealth.app.BaseAppResourceProvider

class AppResourceProvider : BaseAppResourceProvider {
    override suspend fun readBytes(path: String): ByteArray {
        return Res.readBytes(path)
    }
}